export default __webpack_public_path__ + "static/media/one.9c4f06a7.jpg";